import { ChevronDown, ChevronUp } from 'assets'
import Table from 'components/Table'
import CustomInput from 'pages/auth/CustomInput'
import React, { useEffect, useState } from 'react'
import { FormGroup, Input, Label } from 'reactstrap'
import { API_GET_MAMBOO } from 'services'

const HargaLagu = ({ page, projectType, onChangePrice, onCheckHarga, onCheckUsage, usage, price }) => {
  const [isExpand, setIsExpand] = useState({})

  const expandClick = (id) => {
    setIsExpand((prev) => ({ ...prev, [id]: isExpand[id] ? !isExpand[id] : true }))
  }

  const formatValue = (val) => {
    return val ? Number(val).toLocaleString('id-ID') : ""
  }

  const checkIklan = (item) => {
    if (item.project_code === '07') return true
  }

  return (
    <div className='harga-lagu-container' {...(page !== 'create' && { style: { width: '100%' } })}>
      <div className='opsi-pemakaian-lagu' {...(page !== 'create' && { style: { width: '100%' } })}>
        <h3>4. Opsi Pemakaian Lagu</h3>
        <div className='checkbox-wrapper'>
          {page === 'detail' ? usage.is_monthly ?
            <label className='checkbox' style={{ padding: '0' }}>
              Perbolehkan Sewa Bulanan 1, 3, 6, dan 12 Bulan
            </label> : null :
            <label className='checkbox'>
              Perbolehkan Sewa Bulanan 1, 3, 6, dan 12 Bulan
              <input name='is_monthly' checked={usage.is_monthly} type='checkbox' onChange={onCheckUsage} />
              <span className='checkmark'></span>
            </label>
          }

          {page === 'detail' ? usage.is_exclusive ?
            <label className='checkbox' style={{ padding: '0' }}>
              Tersedia Ekslusif
            </label> : null :
            <label className='checkbox'>
              Tersedia Ekslusif
              <input name='is_exclusive' checked={usage.is_exclusive} type='checkbox' onChange={onCheckUsage} />
              <span className='checkmark'></span>
            </label>
          }

        </div>
      </div>
      <div className='kustomisasi-harga' {...(page !== 'create' && { style: { width: '100%' } })}>
        <h3>5. Kustomisasi Harga</h3>
        <div className='harga-header'>
          {/* <div className='check-all'> */}
          {page !== 'detail' &&
            <label className='checkbox' style={{ visibility: 'hidden' }}>
              <input type='checkbox' />
              <span className='checkmark'></span>
            </label>
          }
          {/* </div> */}
          <div className='title-header'> Project Type</div>
          <div className='title-header'>Harga</div>
        </div>
        <div className='list-harga-container'>
          {/* {projectType.map((list, index) => (
            <div className='item-container' {...((list.sub_detail && isExpand) && { style: { borderLeft: '5px solid var(--brand)' } })}>
              <div className='list-harga-item'>
                {page !== 'detail' &&
                  <label className='checkbox'>
                    <input name={list.project_name} checked={price[index]?.is_checked} onChange={(e) => onCheckHarga(e, index)} type='checkbox' />
                    <span className='checkmark'></span>
                  </label>
                }
                <div {...(list.sub_detail && { onClick: expandClick })} className='list-title' style={list.sub_detail && { cursor: 'pointer' }}>{list.project_name}{list.sub_detail && (isExpand ? <ChevronUp /> : <ChevronDown />)}</div>
                <div style={{ flex: '1 0 0', position: 'relative' }}>
                  <span style={{ display: price[index]?.price ? 'block' : 'none', position: 'absolute', top: '17px', left: '25px' }}>Rp</span>
                  <input disabled={page === 'detail' ? true : false} onChange={(e) => onChangePrice(e, index)} value={formatValue(price[index]?.price)} name='price' style={{ padding: price[index]?.price ? '16px 24px 16px 48px' : '16px 24px' }} type="text" placeholder="Rp 0" className='input-text' />
                </div>
              </div>
              {list.sub_detail && list.sub_detail.map((item, childIndex) => (
                <div className='expand-item' style={{ display: `${isExpand ? 'flex' : 'none'}` }}>
                  <div className='list-harga-item'>
                    {page !== 'detail' &&
                      <label className='checkbox'>
                        <input checked={price[index]?.sub_detail[childIndex]?.is_checked} onChange={(e) => onCheckHarga(e, index, childIndex)} type='checkbox' />
                        <span className='checkmark'></span>
                      </label>
                    }
                    <div className='list-title' style={list.sub_detail && { cursor: 'pointer' }}>{item.ads}</div>
                    <div style={{ flex: '1 0 0', position: 'relative' }}>
                      <span style={{ display: price[index]?.sub_detail[childIndex]?.price ? 'block' : 'none', position: 'absolute', top: '17px', left: '25px' }}>Rp</span>
                      <input disabled={page === 'detail' ? true : false} onChange={(e) => onChangePrice(e, index, childIndex)} value={formatValue(price[index]?.sub_detail[childIndex]?.price)} name='price' style={{ padding: price[index]?.sub_detail[childIndex].price ? '16px 24px 16px 48px' : '16px 24px' }} type="text" placeholder="Rp 0" className='input-text' />
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ))} */}

          {projectType.map((list, index) => (
            <div className='item-container' {...((list.project_type && isExpand[list.project_type_cat_id]) && { style: { borderLeft: '5px solid var(--brand)' } })}>
              <div className='list-harga-item'>
                {/* {page !== 'detail' &&
                  <label className='checkbox'>
                    <input name={list.project_name} checked={price[index]?.is_checked} onChange={(e) => onCheckHarga(e, index)} type='checkbox' />
                    <span className='checkmark'></span>
                  </label>
                } */}
                <div {...(list.project_type && { onClick: () => expandClick(list.project_type_cat_id, 'category') })} className='list-title' style={list.project_type && { cursor: 'pointer' }}>{list.category_name}{list.project_type.length > 0 && (isExpand[list.project_type_cat_id] ? <ChevronUp /> : <ChevronDown />)}</div>
                {/* <div style={{ flex: '1 0 0', position: 'relative' }}>
                  <span style={{ display: price[index]?.price ? 'block' : 'none', position: 'absolute', top: '17px', left: '25px' }}>Rp</span>
                  <input disabled={page === 'detail' ? true : false} onChange={(e) => onChangePrice(e, index)} value={formatValue(price[index]?.price)} name='price' style={{ padding: price[index]?.price ? '16px 24px 16px 48px' : '16px 24px' }} type="text" placeholder="Rp 0" className='input-text' />
                </div> */}
              </div>
              {list.project_type.map((item, childIndex) => (
                price[index]?.sub_detail[childIndex]?.price || checkIklan(item) || page !== 'detail' ?
                  <div className={item.sub_detail ? 'item-container' : 'expand-item'} style={{ display: `${isExpand[list.project_type_cat_id] ? 'grid' : 'none'}`, borderLeft: `${isExpand[item.project_type_id] ? '5px solid var(--brand)' : ''}` }}>
                    <div className='list-harga-item'>
                      {(page !== 'detail' && !checkIklan(item)) &&
                        <label className='checkbox'>
                          <input checked={price[index]?.sub_detail[childIndex]?.is_checked} onChange={(e) => onCheckHarga(e, index, childIndex)} type='checkbox' />
                          <input onChange={(e) => onCheckHarga(e, index, childIndex)} type='checkbox' />
                          <span className='checkmark'></span>
                        </label>
                      }
                      <div {...(item.sub_detail && { onClick: () => expandClick(item.project_type_id, 'category') })} className='list-title' style={item.sub_detail && { cursor: 'pointer' }}>{item.project_name}{item.sub_detail && (isExpand[item.project_type_id] ? <ChevronUp /> : <ChevronDown />)}</div>
                      {/* <div className='list-title' style={list.sub_detail && { cursor: 'pointer' }}>{item.project_name}</div> */}
                      {!checkIklan(item) && (
                        <div style={{ flex: '1 0 0', position: 'relative' }}>
                          <span style={{ display: price[index]?.sub_detail[childIndex]?.price ? 'block' : 'none', position: 'absolute', top: '17px', left: '25px' }}>Rp</span>
                          <input disabled={page === 'detail' ? true : false} onChange={(e) => onChangePrice(e, index, childIndex)} value={formatValue(price[index]?.sub_detail[childIndex]?.price)} name='price' style={{ padding: price[index]?.sub_detail[childIndex].price ? '16px 24px 16px 48px' : '16px 24px' }} type="text" placeholder="Rp 0" className='input-text' />
                        </div>
                      )}
                    </div>
                    {item.sub_detail && item.sub_detail.map((subItem, deepIndex) => (
                      price[index]?.sub_detail[childIndex]?.sub_detail[deepIndex]?.price || page !== 'detail' ?
                        < div className='expand-item' style={{ display: `${isExpand[item.project_type_id] ? 'flex' : 'none'}` }}>
                          <div className='list-harga-item'>
                            {page !== 'detail' &&
                              <label className='checkbox'>
                                <input checked={price[index]?.sub_detail[childIndex]?.sub_detail[deepIndex]?.is_checked} onChange={(e) => onCheckHarga(e, index, childIndex, deepIndex)} type='checkbox' />
                                <span className='checkmark'></span>
                              </label>
                            }
                            <div className='list-title'>{subItem.ads}</div>
                            <div style={{ flex: '1 0 0', position: 'relative' }}>
                              <span style={{ display: price[index]?.sub_detail[childIndex]?.sub_detail[deepIndex].price ? 'block' : 'none', position: 'absolute', top: '17px', left: '25px' }}>Rp</span>
                              <input disabled={page === 'detail' ? true : false} onChange={(e) => onChangePrice(e, index, childIndex, deepIndex)} value={formatValue(price[index]?.sub_detail[childIndex]?.sub_detail[deepIndex].price)} name='price' style={{ padding: price[index]?.sub_detail[childIndex].sub_detail[deepIndex].price ? '16px 24px 16px 48px' : '16px 24px' }} type="text" placeholder="Rp 0" className='input-text' />
                            </div>
                          </div>
                        </div>
                        : null
                    ))}
                  </div>
                  : null
              ))}
            </div>
          ))}
        </div>
      </div>
    </div >
  )
}

export default HargaLagu